// extracted by mini-css-extract-plugin
export default {"empty":"Empty_empty__CaE8M","title":"Empty_title__3p8kG","description":"Empty_description__SCu96","absolute":"Empty_absolute__Z27sM"};